import JSZip from 'jszip';
import { kml } from '@tmcw/togeojson';

export { photoCoordinates } from '../../../utils/imageMetadata';

export async function readMapFile(file) {
  if (file.size > 50 * 1024 * 1024) throw new Error('KML/KMZ files are limited to 50 MB. For a large orthomosaic, add the original GeoTIFF (.tif/.tiff) in the results map instead.');
  let xml, zip, entry;
  if (/\.kmz$/i.test(file.name)) {
    zip = await JSZip.loadAsync(file);
    entry = Object.keys(zip.files).find(name => /(^|\/)doc\.kml$/i.test(name)) || Object.keys(zip.files).find(name => /\.kml$/i.test(name));
    if (!entry) throw new Error('The KMZ does not contain a KML file.');
    xml = await zip.file(entry).async('string');
  } else xml = await file.text();
  const doc = new DOMParser().parseFromString(xml, 'text/xml');
  if (doc.querySelector('parsererror') || doc.documentElement.localName !== 'kml') throw new Error('The KML file is invalid.');
  const data = kml(doc);
  const rasters = [];
  for (const overlay of Array.from(doc.getElementsByTagName('GroundOverlay'))) {
    const value = tag => overlay.getElementsByTagName(tag)[0]?.textContent?.trim();
    if (overlay.getElementsByTagName('LatLonBox').length === 0) throw new Error('This layer uses an unsupported grid. Export it with LatLonBox from Google Earth.');
    const rotation = Number(value('rotation') || 0);
    if (!Number.isFinite(rotation)) throw new Error('The image rotation is invalid.');
    const color = value('color') || 'ffffffff';
    const opacity = /^[0-9a-f]{8}$/i.test(color) ? parseInt(color.slice(0, 2), 16) / 255 : 1;
    const bounds = [[Number(value('south')), Number(value('west'))], [Number(value('north')), Number(value('east'))]];
    if (!bounds.flat().every(Number.isFinite) || bounds[0][0] >= bounds[1][0] || bounds[0][1] >= bounds[1][1] || Math.abs(bounds[0][0]) > 85.051129 || Math.abs(bounds[1][0]) > 85.051129 || Math.abs(bounds[0][1]) > 180 || Math.abs(bounds[1][1]) > 180) throw new Error('The image has invalid geographic bounds.');
    const href = value('href');
    const base = entry?.includes('/') ? entry.slice(0, entry.lastIndexOf('/') + 1) : '';
    const image = zip && (zip.file(base + href) || zip.file(href || ''));
    if (!image || !/\.(png|jpe?g|webp)$/i.test(href || '')) throw new Error('Images must be included in the KMZ as PNG, JPG or WebP.');
    const extension = href.split('.').pop().toLowerCase();
    rasters.push({ url: `data:image/${extension === 'jpg' ? 'jpeg' : extension};base64,${await image.async('base64')}`, bounds, rotation, opacity, name: value('name') || file.name });
  }
  if (!data.features.length && !rasters.length) throw new Error('No supported geographic features were found.');
  return { name: file.name, data, rasters, opacity: 1, visible: true, id: `${Date.now()}-${Math.random()}` };
}
